export const BUTTON_TYPES = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
} as const;

export const BUTTON_CLASS_TYPES = {
  PRIMARY: 'p-button-primary',
  SECONDARY: 'p-button-secondary',
  TERTIARY: 'p-button-tertiary',
} as const;
